/** biome-ignore-all lint/style/useNamingConvention: <Use error codes as keys> */
import type TranslationsConfigType from './translation-type';

const nnTranslations: TranslationsConfigType = {
    homeButton: {
        ariaLabel: 'Gå tilbake til fondssparing til barn',
        goToSaving: 'Fondssparing til barn',
        goToBank: 'Nettbank',
    },
    tryAgain: 'Prøv igjen',
    errors: {
        somethingWentWrong: 'Noko gjekk gale!',
        defaultMessage: 'Orsak, det oppstod ein teknisk feil. Ver venleg og prøv igjen om ei tid.',
        errorCode: 'Feilkode',
        copyErrorCode: 'Kopier feilkode',
    },
    errorCode: {
        SPARING_CHILD_ACCOUNT_WEB_INTERNAL_ERROR: 'Intern feil',
        SPARING_CHILD_ACCOUNT_WEB_UNAUTHORIZED: 'Ikkje autorisert',
        SPARING_CHILD_ACCOUNT_WEB_MANDATORY_FIELD_IS_MISSING: 'Påkrevd felt manglar',
        SPARING_CHILD_ACCOUNT_WEB_NOT_SUPPORTED: 'Ikkje støtta',

        SPARING_CUSTOMER_ONBOARDING_MS_WS_INTERNAL_ERROR: 'Intern feil',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_UNAUTHORIZED: 'Ikkje autorisert',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_NOT_SUPPORTED: 'Ikkje støtta',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_CREATE_SHARE_SAVINGS_ACCOUNT_FOR_CHILD_PROCESS_NOT_FOUND:
            'Prosess ikkje funnen',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_CREATE_SHARE_SAVINGS_ACCOUNT_FOR_CHILD_PROCESS_ALREADY_EXISTS:
            'Det finst allereie ein pågåande prosess for dette barnet. Vennlegst gå til oversikta for å fortsetje.',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_SHARE_SAVINGS_ACCOUNT_FOR_CHILD_ALREADY_EXISTS:
            'Aksjesparekonto for barnet eksisterer allereie',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_CREATE_SHARE_SAVINGS_ACCOUNT_FOR_CHILD_PROCESS_ALREADY_FINISHED:
            'Prosessen er allereie fullført',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_BANKREGNR_NOT_SET: 'Bankregisternummer ikkje sett',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_CHILD_IS_NOT_A_MINOR: 'Barnet er ikkje mindreårig',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_CONFIG_FILE_PARSE_ERROR: 'Feil ved lesing av konfigurasjonsfil',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_DECEASED_PERSON_NOT_SUPPORTED: 'Avdød person ikkje støtta',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_PARENTS_ARE_NOT_VALID: 'Foreldre er ikkje gyldige',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_NOTIFICATION_MESSAGE_PARAMETER_MISSING:
            'Manglar parameter i varslingsmelding',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_PORTFOLIO_CREATION_IN_TRADEX_FAILED: 'Oppretting av portefølje feila',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_PERSON_HAS_FALSE_IDENTITY: 'Person har falsk identitet',
    },
    header: 'Aksjespare\u00ADkonto i barnet sitt namn',
    tip: 'Tips',
    ok: 'Ok',
    next: 'Neste',
    accept: 'Godkjenn',
    ingress: 'Hei{}. Her kan du enkelt opprette aksjespare\u00ADkontoar for barn og få oversikt over dine oppgåver.',
    backToOverview: 'Tilbake til oversikt',
    listOfChildren: {
        header: 'Barn',
        noChildrenHeader: 'Vi fann ingen barn registrerte på deg som du kan opprette aksjesparekonto for.',
        noChildrenIngress:
            'Aksjespare\u00ADkonto i namnet til barnet kan berre opprettast av foreldre med registrert foreldre\u00ADansvar for barn under 18 år. Tenesta støttar førebels dessverre ikkje oppretting for eine\u00ADforsørgjarar.',
        noChildrenTips:
            'Dersom du ønskjer å spare i ditt eige namn, kan du opprette ein ny aksjespare\u00ADkonto i Smartspar når du kjøper fond. Deretter kan du gje kontoen namnet til barnet, slik at det blir tydeleg kven du sparer for.',
        error: 'Det oppstod ein liten feil \u2013 vi får dessverre ikkje vist barn og opprettinga av aksjespare\u00ADkonto akkurat no. Ver venleg og prøv igjen seinare, så skal alt vere på plass.',
        onlyOneAccountAllowed:
            'Det er kun mogleg å opprette ein konto per barn her. Dersom du ønskjer fleire, kan du kontakte ein rådgivar.',
    },
    childCard: {
        noAsk: 'Har ikkje aksjespare\u00ADkonto.',
        createAsk: 'Opprett aksjespare\u00ADkonto',
        createAskFor: 'Opprett aksjespare\u00ADkonto for {}',
        giveConsent: 'Sjå over og godkjenn',
        goToStatus: 'Sjå status',
        goToCompleteStatus: 'Sjå detaljar',
        completeKYCForm: 'Fullfør no',
        processInProgress: 'Ventar på samtykke',
        accountAlreadyExists: 'Har aktiv aksjespare\u00ADkonto.',
        waitingForApproverParentConsent: 'Venter på samtykke.',
        needsYourConsent: 'Ventar på ditt samtykke.',
        incompleteProcess: 'Påbegynt oppretting av aksjespare\u00ADkonto.',
        waitingForKYC: 'Kunde\u00ADkontroll manglar',
        pendingKYCAdvisorReview: 'Stoppa av kunde\u00ADkontrollen',
        ariaLabel: {
            processStatusFor: 'Status for eksisterande prosess: {}',
            childElement: 'Barn: {}',
            goToStatusFor: 'Sjå eksisterande prosess for {}',
            goToCompleteStatusFor: 'Sjå detaljar for {}',
            giveConsentFor: 'Sjå over og godkjenn for {}',
            completeKYCFormFor: 'Fullfør anti-hvitvask-skjema for {}',
            startSavingFor: 'Start sparinga for {}',
        },
    },
    usefulInfo: {
        header: 'Nyttig informasjon',
        aboutAskForChild: 'Om sparing i navnet til barnet',
        getAnOverviewOfTheSaving: 'Få oversikt over sparinga',
        howToCreateAManagedAccount: 'Slik blir aksjespare\u00ADkonto oppretta',
    },
    howToCreateInfo: {
        header: 'Slik blir aksjespare\u00ADkonto i namnet til barnet oppretta',
        ingress:
            'For å opprette, vel du kva barn som skal få ein aksjespare\u00ADkonto, oppgjev kontakt\u00ADinformasjon til den andre forelderen og godkjenner vilkåra. Deretter sender vi ein SMS til medforelderen for godkjenning.',
        item1: 'Vel kva barn som skal få aksjespare\u00ADkonto.',
        item2: 'Oppgje mobilnummeret til medforelder.',
        item3: 'Godkjenn vilkåra og fyll ut kundekontroll for barnet.',
        item4: 'Medforelder loggar inn og samtykker.',
        item5: 'Aksjespare\u00ADkontoen blir oppretta og de kan starte sparinga.',
    },
    enterApproverParentInformation: {
        header: 'Kontaktinformasjon til medforelder',
        ingress: 'Vi sender ein SMS til medforelder sitt mobilnummer for å få samtykke til å opprette konto for {}.',
        inputLabel: 'Mobilnummeret til {}',
        phoneValidationError: 'Ver venleg og oppgje eit gyldig mobilnummer med 8 siffer',
    },
    processSummary: {
        header: 'Opp\u00ADsummering',
        accountOwner: 'Kontoeigar',
        parents: 'Disponentar',
        mobileNrTo: 'Mobilnummer til',
        email: {
            subLabel: 'E-posten blir brukt til å sende deg kvittering når ny aksjespare\u00ADkonto er oppretta.',
            yourEmail: 'E-posten din',
            emptyEmailError: 'E-post\u00ADadressa må vere utfylt',
            invalidEmailError: 'E-post\u00ADadressa er ugyldig',
        },
        documentConsent: {
            header: 'Les og godkjenn:',
            documentAvtaleOmAksjesparekonto: 'Avtale om aksjespare\u00ADkonto (pdf)',
            confirmationText: 'Eg stadfester at eg har lese, forstått og akseptert innhaldet i dokumentet.',
            youMustConfirmBeforeProceeding: 'Du må stadfeste innhaldet i dokumentet før du kan fortsetje',
            fetchingDocument: 'Hentar dokument...',
            couldNotFetchDocument: 'Vi fekk ikkje henta dokumentet akkurat no, ver venleg og prøv igjen seinare.',
        },
        invalidProcessSubmitted: 'Ugyldig prosess sendt inn',
        postProcessError: 'Bestillinga kunne ikkje bli fullført',
        postProcessErrorDescription:
            'Vi fekk dessverre ikkje bestilt aksjespare\u00ADkontoen akkurat no, ver venleg og prøv igjen seinare.',
        ariaLabel: { infoHeader: 'Informasjon' },
    },
    pendingProcess: {
        header: {
            completed: 'Ny aksjespare\u00ADkonto er oppretta',
            inProgress: 'Ny aksjespare\u00ADkonto er under behandling',
        },
        details: {
            createdDate: 'Bestilt dato',
            accountOwner: 'Kontoeigar',
            accountManagers: 'Disponentar',
            mobileNrTo: 'Mobilnummer til',
            approverParentPhoneNumber: 'medforelder {}',
            smsHasBeenSentTo: 'SMS sendt til',
            mobileIsMissing: 'Manglar mobilnummer',
            aboutAskLabel: 'Aksjespare\u00ADkonto for barn',
            aboutAskLinkText: 'Om produktet',
            partialAccessAge: 'Barnet får delvis tilgang og kan sjå fonda og spare meir sjølv.',
            handoverAge: 'Barnet får full tilgang og kan ta ut pengar.',
            email: 'E-post for kvittering',
            emailIsMissing: 'Manglar e-post',
        },
        progress: {
            started: 'Påbegynt',
            stopped: 'Stoppa',
            registered: 'Registrert',
            consent: 'Samtykke',
            waitingForApproverParent: 'Ventar på samtykke',
            complete: 'Fullført',
        },
        ariaLabel: {
            processStatus: 'Status for prosessen: {}',
            pageHeader: 'Status for prosessen for barn {}',
        },
        error: 'Vi kunne dessverre ikkje vise prosessen akkurat no, ver venleg og prøv igjen seinare.',
        lastActivity: {
            label: 'Siste aktivitet:',
            waiting: {
                header: 'Du bestilte aksjespare\u00ADkonto',
                description:
                    'Før aksjespare\u00ADkontoen kan opprettast, må den andre forelderen samtykkje. Dette kan den andre forelderen gjere ved å logge inn og fullføre sine oppgåver.',
            },
            completed: {
                header: 'Aksjespare\u00ADkontoen er klar!',
                description:
                    'Barnet har fått ein aksjespare\u00ADkonto. De kan no begynne å spare i aksjefond for barnet i Smartspar.',
            },
            pending: {
                applicantParentHeader: 'Påbegynt aksjespare\u00ADkonto for {}',
                approverParentHeader: '{} har begynt å opprette aksjespare\u00ADkonto for {}',
                description: 'Kundekontrollen blei ikkje fullført under oppretting av aksjespare\u00ADkonto for barn',
            },
            advisorReview: {
                header: 'Kundekontrollen av {} må sjåast av ein rådgivar',
                description:
                    'Ver venleg og kontakt ein rådgivar for å få behandla saka di vidare. Rådgivaren må sjå på saka di før aksjespare\u00ADkontoen kan opprettast.',
            },
            actions: {
                completeKYC: 'Fullfør no',
                smartsparReadMore: 'Les om Smartspar',
            },
        },
        tag: 'Sparing i barnet sitt namn',
    },
    processDetails: {
        header: 'Detaljar',
        headerAria: 'Detaljar om denne kontoopprettelsen',
        ageLimits: 'Aldersgrenser for barnet',
        peopleConnected: 'Tilknytta personar',
        contactInfo: 'Kontakt\u00ADinformasjon',
    },
    approverParentConsent: {
        header: 'Godkjenn oppretting av aksjespare\u00ADkonto for {}',
        headerWithoutName: 'Godkjenn konto\u00ADoppretting',
        ingress:
            '{} ønskjer å opprette aksje\u00ADspare\u00ADkonto for {}. Denne blir berre oppretta dersom du samtykkjer til dette.',
        approveProcessError: 'Vi fikk ikkje godkjent prosessen',
    },
    apiError: {
        processNotFoundHeader: 'Finn ikkje prosessen',
        processNotFoundIngress:
            'Vi kunne ikkje finne prosessen du var ute etter. Ver venleg og sjekk at du har valt riktig prosess.',
        informationModalTitle: 'Bruk gjerne feilkoden når du kontaktar oss',
        informationModalDescription:
            'Feilkoden hjelper oss å raskt forstå kva som har gått gale, slik at du slepp å forklare alt sjølv. Du kan enkelt kopiere koden og lime han inn i e-posten eller meldinga du sender oss.',
    },
    savingLinks: {
        mobileAndOnlineBank: 'Mobilbank & nettbank',
        smartspar: 'Smartspar',
        eika: 'Eika.no',
        eit: 'Eika investortenester',
    },
    success: {
        applicantParentSuccess: {
            header: 'Du er ferdig! Sparinga kan starte så snart den andre forelderen samtykkjer.',
            ingress:
                'Den andre forelderen må samtykkje ved å logge inn på same stad. Aksjespare\u00ADkontoen blir berre oppretta dersom den andre forelderen samtykkjer. Informasjon blei sendt på SMS til den andre forelderen.',
        },
        approverParentSuccess: {
            header: 'Du har gitt samtykke \u2013\n aksjespare\u00ADkontoen er klar!',
            ingress:
                'Barnet ditt har no fått sin heilt eigen aksjespare\u00ADkonto. Kvittering for opprettinga er tilgjengeleg i e-posten din.',
            goToFundOverview: 'Gå til fondsoversikta',
        },
        smartspar: {
            title: 'Spare-app',
            text: 'Barnet sin aksjespare\u00ADkonto er klar. No kan du enkelt starte fondssparing i Smartspar-appen.',
        },
    },
    stop: {
        header: 'Kundekontrollen må sjekkast av ein rådgivar',
        ingress:
            'Ver venleg og kontakt ein rådgivar for å få behandla saka di vidare. Rådgivaren må sjå på saka di før medforelder kan godkjenne at barnet får ein aksjespare\u00ADkonto.',
    },
    smartspar: {
        readMore: 'Les om Smartspar',
        startSaving: 'Start sparinga',
    },
    accountForChildProductBullets: {
        header: 'Kort fortalt om produktet',
        bulletPoint: {
            bothParentsAccess: 'Begge foreldre har tilgang fram til barnet fyller {} år.',
            bothParentsApproval: 'Begge foreldre må godkjenne uttak frå barnet sine fond i denne perioden.',
            notPartOfEstate: 'Går ikkje inn i buet ved skilsmisse/død.',
            lockedUntilHandover:
                'Barnet får delvis tilgang når det er {} år. Barnet kan då halde fram sparinga sjølv og følgje med på utviklinga i fonda sine.',
            withdrawalsNotPossibleUntilHandover:
                'Uttak av pengar vil vere sperra for barnet fram til {} år. Foreldra kan justere ned alder for uttak seinare ved behov.',
            affectsScholarshipLink: 'Påverkar stipend',
            affectsScholarshipRest: 'ved totalbeløp over beløpsgrensa ({} i {}).',
            governorInvolvementLink: 'Statsforvaltaren kan bli involvert',
            governorInvolvementRest: 'ved totalbeløp over 2G ({} i {}).',
        },
        error: 'Vi fekk ikkje vist informasjonen akkurat no, prøv igjen seinare.',
    },
    scholarshipDetails: {
        header: 'Barnet si formue',
        ingress:
            'Viss barnet si formue overstig grensebeløpet ({} i {}), blir stipendet frå Lånekassen kutta. Les meir om reglane hos Lånekassen:',
        linkText: 'Om formue på lånekassen.no',
        tip: 'Dette kan de unngå ved å halde fram med å spare i eige namn før formuesgrensa er nådd, og overføre pengane etter at studia er avslutta.',
        error: 'Vi fekk ikkje vist informasjonen akkurat no, prøv igjen seinare.',
    },
    governorAmountThresholdDetails: {
        over2gHeader: 'Over 2 G',
        over2gIngress:
            'Har barnet meir enn 2 G ({} i {}) i eiga formue, kan statsforvaltaren vere med på å bestemme korleis pengane blir sparte.',
        uncommonHeader: 'Det er ikkje vanleg',
        uncommonIngress:
            'Slik inngripen skjer stort sett dersom barnet arvar eit større beløp eller får ei større forsikringsutbetaling.',
        tip: 'Slik inngripen kan de unngå ved å halde fram med å spare i eige namn før formuesgrensa er nådd.',
        error: 'Vi fekk ikkje vist informasjonen akkurat no, prøv igjen seinare.',
    },
    aboutAccountForChildModal: {
        header: 'Om aksjespare\u00ADkonto for barn',
        ingress: 'Foreldre kan opprette aksjespare\u00ADkonto for barn under {}.',
    },
};

export default nnTranslations;
